const LeftMenuGreenIcon = (props: any) => (
    <svg
        width={10}
        height={49}
        viewBox="0 0 10 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0 0.323242H4C7.31371 0.323242 10 3.00953 10 6.32324V42.3232C10 45.637 7.31371 48.3232 4 48.3232H0V0.323242Z"
            fill="#99AF32"
        />
    </svg>
);

export default LeftMenuGreenIcon;
